import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function BookOpen({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M19 5H20C21.1 5 22 5.89 22 7V19C22 20.1 21.1 21 20 21H4C2.895 21 2 20.1 2 19V7C2 5.89 2.895 5 4 5H5M12 6C12 4.343 10.657 3 9 3H6C5.44 3 5 3.44 5 4V17C5 17.55 5.44 18 6 18H9C10.657 18 12 19.343 12 21M12 6C12 4.343 13.343 3 15 3H18C18.55 3 19 3.448 19 4V17C19 17.55 18.55 18 18 18H15C13.343 18 12 19.343 12 21M12 6V21" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default BookOpen;